import PickupWithTimeWindow from "../../../../mapComponents/PickupWithTimeWindow";
import { VirtualStopMarker } from "../../../../mapComponents/Markers";

const getRouteData = (routesData, driverId) => {
  return routesData.find(
    (route) => route.driverId.toLowerCase() === driverId.toLowerCase()
  );
};

const getPickupData = (pickupsList, pickupId) => {
  return pickupsList.find(
    (p) => p.pickupId.toLowerCase() === pickupId.toLowerCase()
  );
};

const isPickupExistInGrid = (pickups, pickupId) => {
  return pickups.find((pickup) => pickup.pickupId.toLowerCase() === pickupId?.toLowerCase());
};

const getVirtualStopMarker = ({
  pickup,
  stopSequence,
  isSelectedStop,
  theme,
  routeColor,
}) => {
  return (
    <PickupWithTimeWindow
      wrappedComponent={
        <VirtualStopMarker
          backgroundColor={isSelectedStop ? theme.white : routeColor}
          borderColor={isSelectedStop ? routeColor : theme.markerStokeColor}
          stopNo={stopSequence}
        />
      }
      pickupReadyTime={pickup.readyTime}
      pickupCloseTime={pickup.closeTime}
    />
  );
};

export {
  getRouteData,
  getPickupData,
  getVirtualStopMarker,
  isPickupExistInGrid,
};
